import { render } from "./CoffersBronze.vue?vue&type=template&id=1245c34a&scoped=true"
import script from "./CoffersBronze.vue?vue&type=script&lang=js"
export * from "./CoffersBronze.vue?vue&type=script&lang=js"

import "./CoffersBronze.vue?vue&type=style&index=0&id=1245c34a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1245c34a"

export default script